import { render, staticRenderFns } from "./editPackage.vue?vue&type=template&id=0d2b1b5e&scoped=true"
import script from "./editPackage.vue?vue&type=script&lang=ts"
export * from "./editPackage.vue?vue&type=script&lang=ts"
import style0 from "./editPackage.vue?vue&type=style&index=0&id=0d2b1b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b1b5e",
  null
  
)

export default component.exports